/**
 * Side-effect imports for every endpoint file.
 *
 * `injectEndpoints` runs when a file is first evaluated, so an endpoint the
 * app has not imported yet does not exist on the api. The store imports this
 * barrel to guarantee all of them are injected before it is built.
 */
import "./activity-api"
import "./admin-place-reviews-api"
import "./admin-users-api"
import "./agent-runs-api"
import "./agents-api"
import "./assistant-greeting-api"
import "./assistant-suggestions-api"
import "./batch-processing-api"
import "./bookings-api"
import "./chats-api"
import "./collections-api"
import "./detected-trips-api"
import "./early-access-api"
import "./email-previews-api"
import "./event-actor-api"
import "./feature-flag-api"
import "./flight-api"
import "./flight-quotes-api"
import "./folio-documents-api"
import "./for-you-api"
import "./hotel-api"
import "./hotel-bookings-api"
import "./hotel-rooms-api"
import "./image-packs-api"
import "./inspiration-api"
import "./itinerary-api"
import "./location-api"
import "./loyalty-data-issues-api"
import "./loyalty-programs-api"
import "./media-api"
import "./messages-api"
import "./needs-attention-api"
import "./notifications-api"
import "./organization-api"
import "./phone-auth-api"
import "./place-api"
import "./price-quotes-api"
import "./proactive-agents-api"
import "./profile-setup-api"
import "./recent-items-api"
import "./saved-inspirations-api"
import "./saved-places-api"
import "./travel-story-api"
import "./trips-api"
import "./voice-chat-api"
import "./voice-interview-api"
import "./web-events-api"
